"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import Image from "next/image";
import { SectionStrip, type BrandedStyle } from "@/components/layout/SectionStrip";
import { useLabels } from "@/lib/labels/LabelsProvider";
import type { PlayersLeaderboards } from "@/utilities/data/leaders-types";
import { LeaderboardCategory } from "@/components/leaderboards/LeaderboardCategory";
interface Props {
  competitionName?: string;
  competitionLogo?: string;
  leaderboards: PlayersLeaderboards;
  brandedStyle?: BrandedStyle;
  allowPlayerPhotos: boolean;
  /** When true, render a heading with competition name + logo above the grid. */
  showHeader?: boolean;
}
export const CompetitionLeaderboardsBlock: React.FC<Props> = t0 => {
  const $ = _c(32);
  const {
    competitionName,
    competitionLogo,
    leaderboards,
    brandedStyle,
    allowPlayerPhotos,
    showHeader: t1
  } = t0;
  const showHeader = t1 === undefined ? true : t1;
  const labels = useLabels();
  const playerLabel = labels.teamPage.stats.player;
  let t2;
  if ($[0] !== competitionLogo || $[1] !== competitionName || $[2] !== showHeader) {
    t2 = showHeader && competitionName && <header className="flex items-center gap-3 mb-6">{competitionLogo && <div className="w-8 h-8 relative shrink-0"><Image src={competitionLogo} alt={competitionName} fill={true} sizes="32px" className="object-contain" unoptimized={true} /></div>}<h2 className="text-xl font-bold truncate">{competitionName}</h2></header>;
    $[0] = competitionLogo;
    $[1] = competitionName;
    $[2] = showHeader;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== allowPlayerPhotos || $[5] !== labels.players.categories.topScorers || $[6] !== labels.players.stats.goals || $[7] !== leaderboards.topScorers || $[8] !== playerLabel) {
    t3 = <LeaderboardCategory title={labels.players.categories.topScorers} entries={leaderboards.topScorers} statHeader={labels.players.stats.goals} statLabel={labels.players.stats.goals} playerLabel={playerLabel} allowPlayerPhotos={allowPlayerPhotos} />;
    $[4] = allowPlayerPhotos;
    $[5] = labels.players.categories.topScorers;
    $[6] = labels.players.stats.goals;
    $[7] = leaderboards.topScorers;
    $[8] = playerLabel;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== allowPlayerPhotos || $[11] !== labels.players.categories.topAssisters || $[12] !== labels.players.stats.assists || $[13] !== leaderboards.topAssisters || $[14] !== playerLabel) {
    t4 = <LeaderboardCategory title={labels.players.categories.topAssisters} entries={leaderboards.topAssisters} statHeader={labels.players.stats.assists} statLabel={labels.players.stats.assists} playerLabel={playerLabel} allowPlayerPhotos={allowPlayerPhotos} />;
    $[10] = allowPlayerPhotos;
    $[11] = labels.players.categories.topAssisters;
    $[12] = labels.players.stats.assists;
    $[13] = leaderboards.topAssisters;
    $[14] = playerLabel;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  let t5;
  if ($[16] !== allowPlayerPhotos || $[17] !== labels.players.categories.topContributors || $[18] !== labels.players.stats.contributions || $[19] !== leaderboards.topContributors || $[20] !== playerLabel) {
    t5 = <LeaderboardCategory title={labels.players.categories.topContributors} entries={leaderboards.topContributors} statHeader={labels.players.stats.contributions} statLabel={labels.players.stats.contributions} playerLabel={playerLabel} allowPlayerPhotos={allowPlayerPhotos} />;
    $[16] = allowPlayerPhotos;
    $[17] = labels.players.categories.topContributors;
    $[18] = labels.players.stats.contributions;
    $[19] = leaderboards.topContributors;
    $[20] = playerLabel;
    $[21] = t5;
  } else {
    t5 = $[21];
  }
  let t6;
  if ($[22] !== t3 || $[23] !== t4 || $[24] !== t5) {
    t6 = <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">{t3}{t4}{t5}</div>;
    $[22] = t3;
    $[23] = t4;
    $[24] = t5;
    $[25] = t6;
  } else {
    t6 = $[25];
  }
  let t7;
  if ($[26] !== t2 || $[27] !== t6) {
    t7 = <div className="py-10">{t2}{t6}</div>;
    $[26] = t2;
    $[27] = t6;
    $[28] = t7;
  } else {
    t7 = $[28];
  }
  let t8;
  if ($[29] !== brandedStyle || $[30] !== t7) {
    t8 = <SectionStrip brandedStyle={brandedStyle}>{t7}</SectionStrip>;
    $[29] = brandedStyle;
    $[30] = t7;
    $[31] = t8;
  } else {
    t8 = $[31];
  }
  return t8;
};